'use strict';

const authModalLoader = require('../../../auth/authModalLoader').default;

// pass off authentication process to the Auth modal
module.exports = authProps => {
    const {
        action,
        email,
        flow,
        ga
    } = authProps;
    return authModalLoader.show({
        action,
        email,
        flow: flow || authModalLoader.constants.CONTACT_DEALER_FLOW,
        ga
    });
};



// WEBPACK FOOTER //
// ./assets/js/contact/offer/helpers/authHelper.es.js